import Routing from "./routing/Routing";

const AppRoot = () => {
    return (
        <Routing />
    )
}

export default AppRoot;